export const ADD_ITEM = 'ADD_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const UPDATE_NEW_ITEM = 'UPDATE_NEWITEM'
export const RESET_NEW_ITEM = 'RESET_NEWITEM'
export const RESET_ALL_NEW_ITEMS = 'RESET_ALL_NEWITEMS'
export const DELETE_ITEM = 'DELETE_ITEM'
export const REMOVE_ITEM_FROM_ITEM = 'REMOVE_ITEM_FROM_ITEM'
export const UPDATE_ALL_ITEMS = 'UPDATE_ALL_ITEMS' // SYNC?
export const RESET_ALL_ITEMS = 'RESET_ALL_ITEMS'
export const SET_CURRENT_ITEM = 'SET_CURRENTITEM'
export const UPDATE_CURRENT_ITEM = 'UPDATE_CURRENTITEM'
export const SAVE_CURRENT_ITEM = 'SAVE_CURRENTITEM'
export const UPDATE_SPINNER = 'UPDATE_SPINNER'
export const UPDATE_GLOBAL_UI = 'UPDATE_GLOBAL_UI'
export const UPDATE_UI_BY_IDENTITY = 'UPDATE_UI_BY_IDENTITY'
export const UPDATE_UI_BY_IDENTITY_AND_SIDE = 'UPDATE_UI_BY_IDENTITY_AND_SIDE'
export const UPDATE_MEMORY_UI = 'UPDATE_MEMORY_UI'
export const ADD_TOAST = 'ADD_TOAST'
export const REMOVE_TOAST = 'REMOVE_TOAST'
export const CONFIRM_ACTION = 'CONFIRM_ACTION'
export const UPDATE_NAV = 'UPDATE_NAV'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const UPDATE_ITEM_VALIDATION = 'UPDATE_ITEM_VALIDATION'
export const RESET_ITEM_VALIDATION = 'RESET_ITEM_VALIDATION'
export const UNIT_PLACE_BID = 'PLACE_BID'
export const UNIT_CANCEL_BID = 'UNIT_CANCEL_BID'
export const SLOT_ACCEPT_BID = 'SLOT_ACCEPT_BID'
export const SLOT_REJECT_BID = 'SLOT_REJECT_BID'
export const UPDATE_NEW_BID = 'UPDATE_NEW_BID'
export const RESET_NEW_BID = 'RESET_NEW_BID'
export const UPDATE_SIGNIN = 'UPDATE_SIGNIN'
export const RESET_SIGNIN = 'RESET_SIGNIN'
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT'
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const RESET_ACCOUNT = 'RESET_ACCOUNT'
export const UPDATE_NEW_TRANSACTION = 'UPDATE_NEW_TRANSACTION'
export const RESET_NEW_TRANSACTION = 'RESET_NEW_TRANSACTION'
export const RESET_ALL_NEW_TRANSACTIONS = 'RESET_ALL_NEW_TRANSACTIONS'
export const ADD_WEB3_TRANSACTION = 'ADD_WEB3_TRANSACTION'
export const UPDATE_WEB3_TRANSACTION = 'UPDATE_WEB3_TRANSACTION'
export const RESET_WEB3_TRANSACTION = 'RESET_WEB3_TRANSACTION'
export const UPDATE_ALL_BIDS = 'UPDATE_ALL_BIDS'
export const RESET_ALL_BIDS = 'RESET_ALL_BIDS'
export const ADD_NEW_TAG = 'ADD_NEW_TAG'
export const UPDATE_IDENTITY = 'UPDATE_IDENTITY'
export const RESET_IDENTITY = 'RESET_IDENTITY'
export const UPDATE_WALLET = 'UPDATE_WALLET'
export const RESET_WALLET = 'RESET_WALLET'
export const UPDATE_RELAYER_CFG = 'UPDATE_RELAYER_CFG'
export const UPDATE_ANALYTICS_TIMEFRAME = 'UPDATE_ANALYTICS_TIMEFRAME'
export const UPDATE_ANALYTICS = 'UPDATE_ANALYTICS'
export const UPDATE_ADVANCED_ANALYTICS = 'UPDATE_ADVANCED_ANALYTICS'
export const RESET_ANALYTICS = 'RESET_ANALYTICS'
export const UPDATE_CHANNELS_WITH_BALANCE_ALL =
	'UPDATE_CHANNELS_WITH_BALANCE_ALL'
export const RESET_CHANNELS_WITH_BALANCE_ALL = 'RESET_CHANNELS_WITH_BALANCE_ALL'
export const UPDATE_CHANNELS_WITH_OUTSTANDING_BALANCE =
	'UPDATE_CHANNELS_WITH_OUTSTANDING_BALANCE'
export const RESET_CHANNELS_WITH_OUTSTANDING_BALANCE =
	'RESET_CHANNELS_WITH_OUTSTANDING_BALANCE'
export const UPDATE_DEMAND_ANALYTICS = 'UPDATE_DEMAND_ANALYTICS'
export const UPDATE_SELECTED_ITEMS = 'UPDATE_SELECTED_ITEMS'
export const UPDATE_RESOLVE_ENS_ADDRESS = 'UPDATE_RESOLVE_ENS_ADDRESS'
export const UPDATE_ANALYTICS_PERIOD = 'UPDATE_ANALYTICS_PERIOD'
export const UPDATE_PUBLISHER_RECEIPTS = 'UPDATE_PUBLISHER_RECEIPTS'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const UPDATE_ANALYTICS_LAST_CHECKED = 'UPDATE_ANALYTICS_LAST_CHECKED'
export const UPDATE_TARGETING_ANALYTICS = 'UPDATE_TARGETING_ANALYTICS'
export const UPDATE_TABLE_STATE = 'UPDATE_TABLE_STATE'
export const RESET_ALL_TABLES_STATE = 'RESET_ALL_TABLES_STATE'
export const RESET_TABLE_STATE_BY_ID = 'RESET_TABLE_STATE_BY_ID'
